import {
  ArticlePostPreviewActionTypes,
  MediaFileMetadata,
  useArticlePostPreviewContext,
} from './ArticlePostPreviewContext'
import { getImageMetadata, getVideoMetadata } from './utils'
import { isVideo } from 'components/ImagePickerModal/utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useModals } from 'almanac-ui/Modal'
import { DrawersStore } from 'stores/DrawersStore'

export const useMediaFileUploadProgress = (drawersStore?: DrawersStore) => {
  const { dispatch } = useArticlePostPreviewContext()
  const { isMobile } = useResponsiveDesign()
  const { closeAllModals } = useModals()

  const onUploadProgress = (progress: number) => {
    dispatch({
      type: ArticlePostPreviewActionTypes.SET_UPLOADING_MEDIA_FILE_PROGRESS,
      payload: progress,
    })
  }

  const onUploadStart = async (files: File[]) => {
    if (isMobile) {
      drawersStore?.closeDrawer()
    } else {
      closeAllModals()
    }

    let mediaFilesMetadata: MediaFileMetadata[] = []

    await Promise.all(
      files.map(async (file: File, index: number) => {
        if (!file) return

        const fileUrl = URL.createObjectURL(file)

        if (isVideo({ type: file.type })) {
          const videoMetadata = await getVideoMetadata(fileUrl)

          mediaFilesMetadata[index] = {
            ...videoMetadata,
            size: file.size,
          }
        } else {
          const thumbnailUrl = await getImageMetadata(file)
          mediaFilesMetadata[index] = { thumbnail_url: thumbnailUrl, size: file.size, progress: 0 }
        }
      }),
    )

    dispatch({
      type: ArticlePostPreviewActionTypes.SET_UPLOADING_MEDIA_FILES_METADATA,
      payload: mediaFilesMetadata,
    })
  }

  const onUploadEnd = () => {
    dispatch({
      type: ArticlePostPreviewActionTypes.SET_UPLOADING_MEDIA_FILES_METADATA,
      payload: [],
    })
  }

  return {
    onUploadProgress,
    onUploadStart,
    onUploadEnd,
  }
}
